import CryptoJS from "crypto-js";
var LocalStorageUtils = /** @class */ (function () {
    function LocalStorageUtils() {
    }
    LocalStorageUtils.CHUNK_SIZE = 1800;
    LocalStorageUtils.SECRET_KEY = "INTERMAT_COOKIE_SECRET_KEY";
    LocalStorageUtils.encryptData = function (data) {
        return CryptoJS.AES.encrypt(JSON.stringify(data), LocalStorageUtils.SECRET_KEY).toString();
    };
    LocalStorageUtils.decryptData = function (encryptedData) {
        var bytes = CryptoJS.AES.decrypt(encryptedData, LocalStorageUtils.SECRET_KEY);
        return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    };
    LocalStorageUtils.setEncryptedDataInLocalStorage = function (key, data, options) {
        if (options === void 0) { options = {}; }
        var encryptedData = LocalStorageUtils.encryptData(data);
        var totalChunks = Math.ceil(encryptedData.length / LocalStorageUtils.CHUNK_SIZE);
        for (var i = 0; i < totalChunks; i++) {
            var chunkKey = "".concat(key, "_part_").concat(i);
            var chunk = encryptedData.slice(i * LocalStorageUtils.CHUNK_SIZE, (i + 1) * LocalStorageUtils.CHUNK_SIZE);
            localStorage.setItem(chunkKey, chunk);
        }
        localStorage.setItem("".concat(key, "_chunk_count"), totalChunks.toString());
    };
    LocalStorageUtils.getEncryptedDataFromLocalStorage = function (key) {
        var chunkCount = localStorage.getItem("".concat(key, "_chunk_count"));
        if (!chunkCount) {
            return null;
        }
        var reconstructedData = "";
        for (var i = 0; i < parseInt(chunkCount, 10); i++) {
            var chunkKey = "".concat(key, "_part_").concat(i);
            var chunk = localStorage.getItem(chunkKey);
            if (chunk) {
                reconstructedData += chunk;
            }
            else {
                console.error("Falha ao recuperar a parte ".concat(i, " do cookie."));
                return null;
            }
        }
        try {
            return LocalStorageUtils.decryptData(reconstructedData);
        }
        catch (error) {
            console.error("Erro ao descriptografar os dados do cookie:", error);
            return null;
        }
    };
    LocalStorageUtils.removeEncryptedDataFromLocalStorage = function (key) {
        var chunkCount = localStorage.getItem("".concat(key, "_chunk_count"));
        if (chunkCount) {
            for (var i = 0; i < parseInt(chunkCount, 10); i++) {
                localStorage.removeItem("".concat(key, "_part_").concat(i));
            }
            localStorage.removeItem("".concat(key, "_chunk_count"));
        }
    };
    return LocalStorageUtils;
}());
export { LocalStorageUtils };
